<script setup lang="ts">
import SaveButton from "@/components/SaveButton.vue";
import { Xmark } from "@iconoir/vue";
import type { MutationStatus } from "@tanstack/vue-query";
import { ref, toRaw } from "vue";
import { RouterLink } from "vue-router";
import { userRoles } from "./roles";
import type { User } from "./types";

const props = defineProps<{
  user: User;
  savingStatus: MutationStatus;
}>();

defineEmits<{
  update: [user: User];
}>();

const user = ref(structuredClone(toRaw(props.user)));
</script>

<template>
  <form
    class="column box"
    @submit.prevent="
      $emit('update', { ...user, email: user.email.toLowerCase() })
    "
  >
    <div class="multi-columns">
      <div class="column">
        <div>
          <label for="name">Name</label>
          <input id="name" v-model.trim="user.name" type="text" name="name" />
        </div>
        <div>
          <label for="email">E-Mail</label>
          <input
            id="email"
            v-model.trim="user.email"
            type="email"
            name="email"
          />
        </div>
      </div>
      <div>
        <label for="role">Rolle</label>
        <select id="role" v-model="user.role" name="role">
          <option
            v-for="[key, value] in Object.entries(userRoles)"
            :key="key"
            :value="key"
          >
            {{ value }}
          </option>
        </select>
      </div>
    </div>
    <div class="row row-end">
      <RouterLink
        :to="{ name: 'users' }"
        class="button button--secondary"
        role="button"
      >
        <Xmark /> Zurück zur Übersicht
      </RouterLink>
      <SaveButton :saving-status="savingStatus">Speichern</SaveButton>
    </div>
  </form>
</template>
